import { defineMessages } from 'react-intl';

export default defineMessages({
    notificationListTitle: {
        id: 'ri.notification.views.notification-list.title.Go Paperless!',
        defaultMessage: 'Go Paperless!'
    },
    noNotificationsResult: {
        id: 'ri.notification.views.notification-list.No Notificatoin',
        defaultMessage: 'There are no Paperless Options currently active'
    },
});
